import { useState } from "react";
import MapView from "./components/MapView";
import Speedometer from "./components/Speedometer";

function App() {
  const [path, setPath] = useState([]);
  const [destination, setDestination] = useState(null);

  const handleTrack = (pos) => {
    setPath((prev) => [...prev, pos]);
  };

  return (
    <div className="w-screen h-screen bg-black text-white overflow-hidden">
      <MapView path={path} destination={destination} />
      <div className="absolute bottom-4 left-1/2 -translate-x-1/2 bg-black bg-opacity-60 px-6 py-2 rounded-xl">
        <Speedometer onTrack={handleTrack} />
      </div>
    </div>
  );
}

export default App;
